export const filterValueByCriteria = (value: string, criteria: string) => {
  return value.toLowerCase().includes(criteria.toLowerCase());
};
